<template>
  <div>
    <form
      @submit="handleSearch($event)"
    >
      <v-row>
        <v-col sm="12" md="4" lg="4" cols="12">
          <v-text-field
            label="ชื่อสินค้า หรือรหัสสินค้า"
            append-icon="mdi-magnify"
            outlined
            hide-details
            dense
            autocomplete="off"
            v-model="textField"
          ></v-text-field>
        </v-col>
        <v-col sm="12" md="4" lg="4" cols="12">
          <v-autocomplete
            :items="itemsTypeProduct"
            item-value="_id"
            item-text="name"
            label="หมวดหมู่สินค้า"
            outlined
            hide-details
            dense
            autocomplete="off"
            v-model="selectedCategory"
          >
          </v-autocomplete>
        </v-col>
        <v-col sm="12" md="2" lg="2" cols="12">
          <v-btn
            color="warning"
            width="100%"
            class="pa-5"
            depressed
            @click="handleResetData()"
          >
            <v-icon class="mr-5">mdi-refresh</v-icon>
            รีเซ็ต
          </v-btn>
        </v-col>
        <v-col sm="12" md="2" lg="2" cols="12">
          <v-btn
            color="success"
            width="100%"
            class="pa-5"
            depressed
            type="submit"
          >
            <v-icon class="mr-5">mdi-magnify</v-icon>
            ค้นหา
          </v-btn>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import script from '@/views/pages/products/product/search/search.script';

export default script;
</script>
